import React from "react";
import {
  Layout,
  Card,
  Typography,
  Divider,
  Badge,
  Button,
  Row,
  Col,
} from "antd";
import { LeftOutlined, EditOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import CreateNews from "./CreateNews";

const { Content } = Layout;
const { Title, Text } = Typography;

const NewsDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openEdit, setOpenEdit] = React.useState(false);
  const [editData, setEditData] = React.useState(null);

  const newsData = location.state?.newsData;

  if (!newsData) {
    return (
      <div style={{ padding: 40, textAlign: "center" }}>
        No news data found
      </div>
    );
  }

  return (
    <div style={{ padding: 24, background: "#f5f7fb", minHeight: "100vh" }}>

      <CreateNews
        visible={openEdit}
        editdata={editData}
        handleCancel={() => {
          setOpenEdit(false);
          setEditData(null);
        }}
        onSuccess={() => {
          setOpenEdit(false);
          setEditData(null);
          navigate(-1); // go back and refresh list if needed
        }}
      />


      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
        <Button
          icon={<LeftOutlined />}
          type="link"
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
        {/* 
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={() => {
            const mappedData = {
              fld_news_title: newsData.title,
              fld_news_description: newsData.description,
              fld_news_type_name: newsData.type,
              fld_news_image: newsData.image,
              fld_publish_date: newsData.createdDate,
              fld_status: newsData.status,
              fld_hyper_link: newsData.link,
              fld_news_id: newsData.id,
              fld_rf_id: newsData.rf_id, 
              fld_news_sw_id: newsData.news_sw_id,
            };

            setEditData(mappedData);
            setOpenEdit(true);
          }}
        >
          Edit News
        </Button> */}
      </div>

      <Layout>
        <Content>
          {/* HERO */}
          <div
            style={{
              position: "relative",
              borderRadius: 16,
              overflow: "hidden",
              boxShadow: "0 6px 24px rgba(0,0,0,0.15)",
            }}
          >
            <img
              src={newsData.image}
              alt="news"
              style={{
                width: "100%",
                height: 200,
                objectFit: "cover",
              }}
            />

            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                padding: 20,
              }}
            >
              <Title level={3} style={{ color: "#fff", margin: 0 }}>
                {newsData.title}
              </Title>

              <div style={{ marginTop: 8 }}>
                <Badge
                  count={newsData.type}
                  style={{
                    backgroundColor: "#1677ff",
                  }}
                />
              </div>
            </div>
          </div>

          {/* MAIN CONTENT */}
          <div style={{ marginTop: 24 }}>
            <Card
              style={{
                borderRadius: 16,
                boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              }}
            >

              {/* Sub Description */}
              <Title level={4}>📰 Short News Description</Title>
              <Text type="secondary" style={{ fontSize: 15 }}>
                {newsData.subdescription || "No Sub description available"}
              </Text>
              {/* Description */}
              <Title level={4}>📰 Description</Title>
              <Text type="secondary" style={{ fontSize: 15 }}>
                {newsData.description || "No description available"}
              </Text>

              <Divider />

              {/* Info Section */}
              <Title level={4}>📌 Long News Information</Title>

              <Row gutter={[16, 16]} style={{ marginTop: 12 }}>
                <Col xs={24} md={12}>
                  <Card
                    style={{
                      borderRadius: 12,
                      background: "#fafafa",
                    }}
                  >
                    <Text strong>News Type</Text>
                    <div style={{ marginTop: 6 }}>
                      {newsData.type}
                    </div>
                  </Card>
                </Col>

                <Col xs={24} md={12}>
                  <Card
                    style={{
                      borderRadius: 12,
                      background: "#fafafa",
                    }}
                  >
                    <Text strong>News ID</Text>
                    <div style={{ marginTop: 6 }}>
                      {newsData.id}
                    </div>
                  </Card>
                </Col>
              </Row>

              <Divider />

              {/* Extra Section (Optional Enhancement) */}
              <Title level={4}>📅 Published Info</Title>
              <Row gutter={[16, 16]} style={{ marginTop: 12 }}>
                <Col xs={24} md={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Status</Text>
                    <div style={{ marginTop: 6 }}>
                      <Badge status="processing" text="Published" />
                    </div>
                  </Card>
                </Col>

                <Col xs={24} md={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Category</Text>
                    <div style={{ marginTop: 6 }}>
                      {newsData.type}
                    </div>
                  </Card>
                </Col>
              </Row>
                  <Row gutter={[16, 16]} style={{ marginTop: 12 }}>
                <Col xs={24} md={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>Published Date</Text>
                    <div style={{ marginTop: 6 }}>
                     {newsData.createdDate}
                    </div>
                  </Card>
                </Col>

                <Col xs={24} md={12}>
                  <Card style={{ borderRadius: 12 }}>
                    <Text strong>End Date</Text>
                    <div style={{ marginTop: 6 }}>
                      {newsData.endDate}
                    </div>
                  </Card>
                </Col>
              </Row>
            </Card>
          </div>
        </Content>
      </Layout>
    </div>
  );
};

export default NewsDetails;